var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated || _vm.isLoading || _vm.isCheckingStatus)?_c('Loader'):_c('router-view'),(_vm.popup.visible)?_c('doc-frame'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }